(function () {
  document.querySelectorAll('[data-application-stepper]').forEach(function (section) {
    var steps = section.querySelectorAll('[data-application-step]');
    var images = section.querySelectorAll('[data-application-image]');
    var overlays = section.querySelectorAll('[data-application-overlay]');
    var nextBtn = section.querySelector('[data-application-next]');
    if (!steps.length || !nextBtn) return;

    var current = 0;
    var total = steps.length;

    var setActive = function (index) {
      current = (index + total) % total;
      var indexStr = String(current);
      steps.forEach(function (el) {
        el.setAttribute('data-active', el.getAttribute('data-step-index') === indexStr ? 'true' : 'false');
      });
      images.forEach(function (el) {
        el.setAttribute('data-active', el.getAttribute('data-step-index') === indexStr ? 'true' : 'false');
      });
      overlays.forEach(function (el) {
        el.setAttribute('data-active', el.getAttribute('data-step-index') === indexStr ? 'true' : 'false');
      });
    };

    nextBtn.addEventListener('click', function () {
      setActive(current + 1);
    });
  });
})();
